import {Component, OnInit} from '@angular/core';
import {Maintenance} from "../../../../model/dto/status/Maintenance";
import {Incident} from 'src/model/dto/status/Incident';
import {MaintenanceProvider} from "../../../../providers/status/maintenanceProvider";
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {CheckPermission} from "../../../../service/checkPermission";
import Swal from "sweetalert2";

@Component({
  selector: 'app-service-status',
  templateUrl: './service-status.component.html',
  styleUrls: ['./service-status.component.scss']
})
export class ServiceStatusComponent implements OnInit {

  maintenance: Maintenance[] = [];
  newsObj = null;

  constructor(private checkPermission: CheckPermission,
              private maintenanceProvider: MaintenanceProvider,
              private domSanitizer: DomSanitizer) {
  }

  ngOnInit() {
    // this.getOverallData();
    this.getStatus();
    this.getIncidents();
  }

  warningStatus() {
    return JSON.parse(localStorage.getItem('warnings'));
  }

  toggleWarnings() {
    const warnings = localStorage.getItem('warnings') === 'true';
    localStorage.setItem('warnings', warnings ? 'false' : 'true');
  }

  getIncidents() {
    this.maintenanceProvider.getAllIncident().then((value: Incident[]) => {
      let incident = value.filter(x => x.name.includes("[NEWS_FARMCONT]"));

      if (incident.length == 0) return;
      this.newsObj = {
        title: incident[0].name.split("[NEWS_FARMCONT]")[1].replace(/_/g, " "),
        description: incident[0].updates[0].message.split("§")[0],
        link: incident[0].updates[0].message.split("§")[1]
      }
      this.newsObj.link != undefined ? this.newsObj.link = this.domSanitizer.bypassSecurityTrustUrl(this.newsObj.link) : this.newsObj.link = null;
    });
  }

  getStatus() {
    this.maintenance = [];
    this.maintenanceProvider.getAllMaintenance().then((value: Maintenance[]) => {
      const version = value.find(x => x.name.includes("[VERSION_FARMCONT")).updates[0].message;
      const userRoles = this.checkPermission.getRoles();

      value.filter(x => x.name.includes("[MAINTENANCE_FARMCONT]")).forEach(x => {
        x.name = x.name.split("[MAINTENANCE_FARMCONT]")[1].replace(/_/g, " ");
        const maintenanceRoles = x.components.filter(y => y.name.includes("ROLE_")).map(y => y.name);
        x.components = x.components.filter(y => !y.name.includes("ROLE_"));

        const hasAccess = !maintenanceRoles.length || maintenanceRoles.some(role => userRoles.includes(role));
        const isVersionMismatch = x.components.some(c => c.name === 'Versão') && version !== require('../../../../../package.json').version;

        if (hasAccess && (isVersionMismatch || !x.components.some(c => c.name === 'Versão'))) {
          this.maintenance.push(x);
        }
      });
    });
  }
}
